import { useContext } from 'react';

// Components
import { RichText } from '@/components/RichText/RichText';
import { Context } from '@/components/Store';

const ProductPrice = () => {
	const [state] = useContext(Context);

	return state?.pricingText?.length ? (
		<p className="price">
			<RichText message={state.pricingText} />
		</p>
	) : null;
};

export { ProductPrice };
